"use strict";

exports.__esModule = true;
exports.setQueryParameters = exports.init = exports.default = void 0;
var _index = require("../../../swcp-base/js/index");
var _actionTypes = require("./actionTypes");
class Actions extends _index.ActionHelper {
  constructor() {
    super({
      singular: "ssoauth"
    });
  }
}
const actions = new Actions();
const init = data => {
  return dispatch => {
    dispatch({
      type: _actionTypes.INIT_SSOAUTH,
      data: data
    });
  };
};
exports.init = init;
const setQueryParameters = queryParams => {
  return function (dispatch) {
    dispatch({
      type: _actionTypes.SET_QUERY_PARAMETERS,
      payload: queryParams
    });
  };
};
exports.setQueryParameters = setQueryParameters;
var _default = exports.default = actions;